export const INTERNALANNOUNCEMENT_CREATE_RESET = 'INTERNALANNOUNCEMENT_CREATE_RESET'
export const INTERNALANNOUNCEMENT_CREATE_SET_CREATED = 'INTERNALANNOUNCEMENT_CREATE_SET_CREATED'
export const INTERNALANNOUNCEMENT_CREATE_SET_ERROR = 'INTERNALANNOUNCEMENT_CREATE_SET_ERROR'
export const INTERNALANNOUNCEMENT_CREATE_SET_VIOLATIONS = 'INTERNALANNOUNCEMENT_CREATE_SET_VIOLATIONS'
export const INTERNALANNOUNCEMENT_CREATE_TOGGLE_LOADING = 'INTERNALANNOUNCEMENT_CREATE_TOGGLE_LOADING'
